import styles from './RadioInput.module.scss';
import { useContext, useMemo, type ReactNode } from 'react';
import { InputShared } from './InputShared';
import clsx from 'clsx';
import { RadioInputContext } from './RadioInputContext';
import { FormFieldContext } from '../form/FormFieldContext';

interface Props {
  children: ReactNode;
  grow?: 'auto' | 'even' | 'fill';
  label: string;
  name: string;
  onValue?: (value: string) => void;
  selectedValue: string | null;
  valid?: boolean;
}

export function RadioInput({
  children,
  grow = 'auto',
  label,
  onValue,
  selectedValue,
  valid,
  ...props
}: Props) {
  const formFieldContext = useContext(FormFieldContext);
  const name = props.name ?? formFieldContext.name;

  const contextValue = useMemo(
    () => ({ selectedValue, grow, name, onValue }),
    [selectedValue, grow, name, onValue],
  );

  return (
    <RadioInputContext.Provider value={contextValue}>
      <InputShared id="" label={label} name={name} valid={valid}>
        {() => (
          <div
            className={clsx(
              styles['radio-input'],
              styles[`radio-input-grow-${grow}`],
            )}
          >
            {children}
          </div>
        )}
      </InputShared>
    </RadioInputContext.Provider>
  );
}
